import { createFileRoute } from "@tanstack/react-router";
import AdminProgramsPage from "@/pages/admin/programs";

export const Route = createFileRoute("/app/admin/programs")({
  component: AdminProgramsPage,
});
